// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";

function mapTerm(term) {
  switch (term) {
    case "03" :
      return "Акмолинская область";
    case "06" :
      return "Актюбинская область";
    case "09" :
      return "Алматинская область";
    case "15" :
      return "Атырауская область";
    case "18" :
      return "Восточно-Казахстанская область";
    case "21" :
      return "Жамбылская область";
    case "27" :
      return "Западно-Казахстанская область";
    case "30" :
      return "Карагандинская область";
    case "33" :
      return "Кызылординская область";
    case "39" :
      return "Костанайская область";
    case "43" :
      return "Мангистауская область";
    case "45" :
      return "Павлодарская область";
    case "48" :
      return "Северо-Казахстанская область";
    case "58" :
      return "Туркестанская область";
    case "59" :
      return "Шымкент";
    case "60" :
      return "Алматы";
    case "62" :
      return "Астана";
    case "70" :
      return "Область Жетысу";
    case "71" :
      return "Область Абай";
    case "72" :
      return "Область Улытау";
    default:
      return term;
  }
}

function ogdLength(ogds) {
  return Belt__Belt_List.reduce(ogds, 0, (function (acc, param) {
    const ogds = param[1];
    const divider = param[0] === "" || Stdlib__List.length(ogds) === 0 ? 0 : 1;
    return (acc + divider | 0) + Stdlib__List.length(ogds) | 0;
  }));
}

function takeOgds(ogds, count) {
  const x = {
    contents: 0
  };
  return Stdlib__List.map((function (param) {
    const filteredArr = Stdlib__List.filter((function (a) {
      x.contents = x.contents + 1 | 0;
      return x.contents <= count;
    }), param[1]);
    return [
      param[0],
      filteredArr
    ];
  }), ogds);
}

function wordFound(words, str) {
  const wordList = Stdlib__Array.to_list(Stdlib__String.trim(words).split(" ", undefined));
  return Stdlib__List.for_all((function (w) {
    return str.toLowerCase().includes(w.toLowerCase(), undefined);
  }), wordList);
}

export {
  mapTerm,
  ogdLength,
  takeOgds,
  wordFound,
}
/* No side effect */
